var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg063Pin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 2.29003C14.4563 2.03637 14.0866 1.9373 13.7401 2.03015C13.3936 2.12299 13.123 2.39364 13.0301 2.74015C12.9373 3.08665 13.0363 3.45637 13.29 3.71003L13.49 3.91003L5.48999 10.11L4.67999 9.29003C4.28787 8.8979 3.65211 8.8979 3.25999 9.29003C2.86787 9.68215 2.86787 10.3179 3.25999 10.71L7.57999 15L2.33999 20.24C2.15068 20.4278 2.04419 20.6834 2.04419 20.95C2.04419 21.2167 2.15068 21.4723 2.33999 21.66C2.52775 21.8493 2.78335 21.9558 3.04999 21.9558C3.31663 21.9558 3.57222 21.8493 3.75999 21.66L8.99999 16.4L13.29 20.68C13.4778 20.8693 13.7333 20.9758 14 20.9758C14.2666 20.9758 14.5222 20.8693 14.71 20.68C14.8993 20.4923 15.0058 20.2367 15.0058 19.97C15.0058 19.7034 14.8993 19.4478 14.71 19.26L13.91 18.46L20.09 10.46L20.29 10.66C20.4778 10.8493 20.7334 10.9558 21 10.9558C21.2666 10.9558 21.5222 10.8493 21.71 10.66C21.8993 10.4723 22.0058 10.2167 22.0058 9.95003C22.0058 9.68339 21.8993 9.42779 21.71 9.24003L14.71 2.29003ZM12.48 17L6.99999 11.53L15 5.33003L18.75 9.08003L12.48 17Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg063Pin);
export default __webpack_public_path__ + "static/media/063-pin.8a160306edcd9a11f461dac96a6b3464.svg";
export { ForwardRef as ReactComponent };